export function WorkStep({ number, title, description, image }) {
  return (
    <div className="bg-white dark:bg-gray-700 rounded-lg shadow-md overflow-hidden">
      <div className="h-48 overflow-hidden">
        <img src={image} alt={`Step ${number}`} className="w-full h-full object-cover" />
      </div>
      <div className="p-6">
        <div className="flex items-center">
          <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-full bg-indigo-100 dark:bg-indigo-900">
            <span className="text-indigo-600 dark:text-indigo-200 font-bold">{number}</span>
          </div>
          <h3 className="ml-4 text-lg font-medium text-gray-900 dark:text-white">{title}</h3>
        </div>
        <p className="mt-3 text-base text-gray-500 dark:text-gray-300">{description}</p>
      </div>
    </div>
  );
} 